import { TeamActivityPage as TeamActivityPageComponent } from '@carboncopyco/components';
import WorkspaceLayout from '../../components/Workspaces/WorkspaceLayout';
import { useCustomNavigate } from '../../hooks/useCustomNavigate';

export function TeamActivityPage() {
  const {
    navigateToDemoPageByWorkspace,
    navigateToClonePageByWorkspace,
    navigateToPresentationPageFromHomepage,
  } = useCustomNavigate();

  return (
    <WorkspaceLayout>
      <div className="bg-ds-accent3-100 g-ds-accent3-200 h-full overflow-y-auto">
        <TeamActivityPageComponent
          goToDemoPageByWorkspace={(id, workspaceId) =>
            navigateToDemoPageByWorkspace(String(id), workspaceId)
          }
          goToClonePageByWorkspace={navigateToClonePageByWorkspace}
          goToPresentationPageFromHomepage={
            navigateToPresentationPageFromHomepage
          }
        />
      </div>
    </WorkspaceLayout>
  );
}
